import React from 'react';
import ExistingBrandsHero from './ExistingBrandsHero';
import MembershipBenefits from './MembershipBenefits';
import BrandLogos from '../Home/HomepageV2/BrandLogos';
import FeaturedIn from './FeaturedIn';
import SaveSection from './SaveSection';
import CTASection from './CTASection';
import GrowSales from './GrowSales';
import MarketingTools from './MarketingTools';
import SocialProof from './SocialProof';

const ExistingBrandsLandingPage = () => {
  return (
    <div className="existing-brands-landing-page">
      <ExistingBrandsHero />
      <BrandLogos style={{ marginTop: '40px' }} />
      <MembershipBenefits />
      <FeaturedIn />
      <SaveSection />
      <CTASection
        title="Join Pietra, and start making more money."
        description="Get a free audit and see how you can start saving today"
      />
      <GrowSales />
      <CTASection
        title="Time is money. Save both."
        description="Save 30-50% with Pietra."
        style={{ backgroundColor: '#000', color: '#FFF' }}
      />
      <MarketingTools />
      <SocialProof />
    </div>
  );
};

export default ExistingBrandsLandingPage;
